import React, { useState } from 'react';
import Button from '../../forms/Button';
import Form from '../forms/FullScreenForm';
import logo from '../../../assets/images/logo.png';
import { Link } from 'react-router-dom';
import { ROOT_PATH } from '../../../constants/routes';

const SecuritySettingsForm = props => {
    const { onReset2FASubmit, loading, remainingRecoveryCodes } = props;

    const [activeAction, setActiveAction] = useState(null); // 'reset'

    const handleReset2FASubmit = () => {
        setActiveAction('reset');
        onReset2FASubmit();
    };

    const getRecoveryCodesStatus = () => {
        if (remainingRecoveryCodes === null || remainingRecoveryCodes === undefined) {
            return { text: 'Loading...', className: '' };
        }
        if (remainingRecoveryCodes <= 3) {
            return {
                text: `${remainingRecoveryCodes} of 10 remaining`,
                className: 'is-warning'
            };
        }
        return {
            text: `${remainingRecoveryCodes} of 10 remaining`,
            className: ''
        };
    };

    const status = getRecoveryCodesStatus();

    return (
        <Form
            onSubmit={e => e.preventDefault()}
            canSubmit={false}
            header={<img className="ckp-forms-logo" src={logo} alt="Logo" />}
            body={
                <>
                    <div className="ckp-security-settings-section">
                        <div className="ckp-security-settings-action">
                            <h3 className="ckp-security-settings-section-title">Recovery Codes</h3>
                            <div className="ckp-security-settings-status">
                                <span className={`ckp-security-settings-status-value ${status.className}`}>
                                    {status.text}
                                </span>
                            </div>
                        </div>

                        <div className="ckp-security-settings-action">
                            <h4 className="ckp-security-settings-action-title">Reset Two-Factor Authentication</h4>
                            <p className="ckp-security-settings-description">Reset your 2FA to set up a new device.</p>
                            <Button
                                loading={loading && activeAction === 'reset'}
                                inactive={loading && activeAction !== 'reset'}
                                label="Reset 2FA"
                                onClick={handleReset2FASubmit}
                            />
                        </div>
                    </div>
                    <div className="ckp-security-settings-footer">
                        <Link className="ckp-forms-cancel" to={ROOT_PATH}>
                            BACK TO LOGIN
                        </Link>
                    </div>
                </>
            }
        />
    );
};

export default SecuritySettingsForm;
